<template>
<nav id="site-navigation" style="background: #25D366;" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <a href="https://gb-dwnplus.org/" title="GBWhatsApp" rel="home">
          <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/logo.webp" title="GBWhatsApp">
        </a>
      </div>
      <p class="main-title" itemprop="headline">
        <a href="https://gb-dwnplus.org/" rel="home">
          GBDwnplus
        </a>
      </p>
    </div>
    <ul id="menu-primary-menu" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
      <li class="menu-item menu-item-has-children head-nav-dropdown">
        <a href="https://gb-dwnplus.org/features/">Features</a>
        <ul class="sub-menu head-nav-submenu head-nav-submenu--stacked">
          <li class="menu-item"><a href="https://gb-dwnplus.org/features/privacy/">Privacy</a></li>
          <li class="menu-item"><a href="https://gb-dwnplus.org/features/media/">Media</a></li>
          <li class="menu-item"><a href="https://gb-dwnplus.org/features/multi-account/">Multi-Account</a></li>
        </ul>
      </li>
      <li class="menu-item menu-item-has-children head-nav-dropdown">
        <a href="https://gb-dwnplus.org/use-cases/">Use Cases</a>
        <ul class="sub-menu head-nav-submenu head-nav-submenu--stacked">
          <li class="menu-item"><a href="https://gb-dwnplus.org/use-cases/business/">Business</a></li>
          <li class="menu-item"><a href="https://gb-dwnplus.org/use-cases/social-media/">Social Media</a></li>
          <li class="menu-item"><a href="https://gb-dwnplus.org/use-cases/gaming/">Gaming</a></li>
          <li class="menu-item"><a href="https://gb-dwnplus.org/use-cases/international/">International</a></li>
        </ul>
      </li>
      <li>
        <a href="https://gb-dwnplus.org/blog/" class="blogs-btn">Blogs</a>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <!-- mobile -->
      <div class="mobile-menu" v-if="$global.isMobileDevice()">
        <div class="menu-toggle" @click="isMenuClicked=!isMenuClicked">
          <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="close button" v-else>
        </div>
      </div>
      <!-- pc -->
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <!-- <li id="menu-item-32" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-13 current_page_item menu-item-32">
          <router-link :to="{ name: `${selectedLanguage}-gb` }" exact>{{ this.translation[selectedLanguage].home }}</router-link>
        </li> -->
        <li class="menu-item menu-item-has-children head-nav-dropdown">
          <a href="/features/">Features</a>
          <ul class="sub-menu head-nav-submenu">
            <li class="menu-item"><a href="/features/privacy/">Privacy</a></li>
            <li class="menu-item"><a href="/features/media/">Media</a></li>
            <li class="menu-item"><a href="/features/multi-account/">Multi-Account</a></li>
          </ul>
        </li>
        <li class="menu-item menu-item-has-children head-nav-dropdown">
          <a href="/use-cases/">Use Cases</a>
          <ul class="sub-menu head-nav-submenu">
            <li class="menu-item"><a href="/use-cases/business/">Business</a></li>
            <li class="menu-item"><a href="/use-cases/social-media/">Social Media</a></li>
            <li class="menu-item"><a href="/use-cases/gaming/">Gaming</a></li>
            <li class="menu-item"><a href="/use-cases/international/">International</a></li>
          </ul>
        </li>
        <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <a href="/download/" class="download-btn">Download</a>
        </li>
        <li>
          <a href="/blog/" class="blogs-btn">Blogs</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import Search from './Search.vue';
import doc from '@/documents/blogs.js';
export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  components: {
    Search,
  },
  data() {
    return {
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      lang: [{
          lang: 'en',
          val: '🇺🇸 English'
        },
        {
          lang: 'ar',
          val: '🇦🇪 اَلْعَرَبِيَّةُ'
        },
        {
          lang: 'id',
          val: '🇮🇩 Bahasa Indonesia'
        },
        {
          lang: 'pt',
          val: '🇵🇹 Português'
        },
        {
          lang: 'es',
          val: '🇪🇸 Español'
        },
        {
          lang: 'hi',
          val: '🇮🇳 हिंदी'
        },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          mod: 'WhatsApp Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          mod: 'व्हाट्सएप मोड्स',
        },
      },
    }
  },
  computed: {
    blogNavItems() {
      const list = doc.bloglist[this.selectedLanguage] || doc.bloglist.en;
      return Array.isArray(list) ? list : [];
    },
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    }
  },
  methods: {
    changeLanguage(lang) {
      console.log("changelang: ", lang);
      console.log("page: ", this.page);
      this.$router.push({
        name: `${this.selectedLanguage}-${this.page}`
      });
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    width: 80%;
    margin: 0 auto;
    z-index: 9999;
    position: relative;
  }
}


#backtop {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 50%;
  box-sizing: content-box;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}



.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;
    li {
      a {
        font-weight: 500 !important;
      }
    }
  }
}

/* Desktop: flyout submenus */
#site-navigation .main-nav .head-nav-dropdown {
  position: relative;
}

#site-navigation .main-nav .head-nav-submenu {
  display: none;
  position: absolute;
  left: 0;
  top: 100%;
  min-width: 220px;
  margin: 0 !important;
  padding: 8px 0 !important;
  list-style: none !important;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 10020;
}

#site-navigation .main-nav .head-nav-dropdown:hover > .head-nav-submenu {
  display: block;
}

#site-navigation .main-nav .head-nav-submenu .menu-item {
  margin: 0 !important;
}

#site-navigation .main-nav .head-nav-submenu a {
  display: block;
  padding: 10px 20px !important;
  line-height: 1.35 !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  color: #303030 !important;
  white-space: nowrap;
}

#site-navigation .main-nav .head-nav-submenu a:hover {
  color: #0089ae !important;
  background: #f4f4f4;
}

@media screen and (max-width: 768px) {

  .inside-navigation {

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      /* 突破 80% 容器，与屏宽对齐（避免子菜单块显得过窄、圆点落在灰块外） */
      right: auto;
      width: 100vw;
      max-width: 100vw;
      margin-left: -50vw;
      z-index: 1001;
      padding: 0 !important;
      list-style: none !important;
      box-sizing: border-box;
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);

      ul,
      ol {
        list-style: none !important;
        list-style-image: none !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      > li {
        list-style: none !important;
        margin: 0 !important;
      }

      .menu-item,
      li.menu-item {
        list-style: none !important;
        margin: 0 !important;
        padding: 0 !important;
        background: #fff;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      }

      .head-nav-dropdown > a {
        font-size: 15px;
        font-weight: 600;
        letter-spacing: 0.02em;
        text-align: left;
        color: #1a1a1a !important;
        padding: 16px 20px !important;
        display: block;
      }

      > li:not(.menu-item-has-children) > a {
        font-size: 15px;
        text-align: left;
        color: #1a1a1a !important;
        padding: 16px 20px !important;
        display: block;
        background: #fff;
      }

      .head-nav-submenu--stacked {
        position: static;
        display: block !important;
        width: 100%;
        box-sizing: border-box;
        box-shadow: none;
        border-radius: 0;
        margin: 0 !important;
        padding: 4px 0 14px !important;
        background: linear-gradient(180deg, #eef8f0 0%, #e8f5eb 100%);
        border-bottom: none;
        border-left: 3px solid #1fa855;

        .menu-item {
          padding: 0 !important;
          background: transparent;
          border-bottom: none;

          a {
            font-size: 14px;
            font-weight: 500;
            text-align: left;
            color: #2d3337 !important;
            padding: 12px 20px 12px 24px !important;
            display: block;
            line-height: 1.4;
          }

          a:active,
          a:hover {
            background: rgba(37, 211, 102, 0.12);
            color: #0d6b3a !important;
          }
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .language-selector {
        width: 60%;

        #language-select {
          width: 100%;
        }
      }

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }

      .search-toggle {
        display: block;
        padding: 12px 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
